// @ts-check
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';
import toast from '@liquidweb-dev/undercurrent/toast';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useStateDataRemove = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/account/user/stateData/index.raw').LWApiPublicAccountUserStateDataRemoveParamsRawI} params */
			(params) => api.account.user.stateData.apiRaw.remove(params),

		onSuccess: (data, vars) => {
			queryClient.invalidateQueries({
				queryKey: ['/account/user/statedata/listforkey', { key: vars.key }],
			});
		},

		onError: snackbarError,
	});
};

export const useRemoveFavorite = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {{ uuid: string }} params */
			({ uuid }) =>
				api.account.user.stateData.apiRaw.remove({
					key: 'favorites',
					uuid,
				}),

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['/account/user/statedata/listforkey', { key: 'favorites' }],
			});

			toast.success('Removed from favorites');
		},

		onError: snackbarError,
	});
};

export default useStateDataRemove;
